<div id="content" class="extensible">
  <div class="calendar-header-row">
    <!-- LEFT: date navigation + today + occupancy -->
    <div class="calendar-header-left">
      <div class="date-controller">
        @if (viewDate() !== null) {
          <button
            mat-icon-button
            mwlCalendarPreviousView
            [view]="view"
            [viewDate]="viewDateForCalendar()"
            (viewDateChange)="onChangeWeekClicked($event)"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          <h3 class="date-range-label">{{ viewDateForCalendar() | CalendarDateToCustomFormat }}</h3>
          <button
            mat-icon-button
            mwlCalendarNextView
            [view]="view"
            [viewDate]="viewDateForCalendar()"
            (viewDateChange)="onChangeWeekClicked($event)"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
        }
      </div>
      @if (viewDate() !== null && active_contract !== null) {
        <button mat-icon-button [matTooltip]="'Hoy'" (click)="onClickToday()">
          <mat-icon>today</mat-icon>
        </button>
        @if (userOptions) {
          <mat-form-field appearance="outline" class="nobottom small" [formGroup]="filterForm">
            <mat-select
              placeholder="Ocupación de otros usuarios"
              multiple
              formControlName="ocupation_of_users"
              [compareWith]="compareOcupationUserIds"
            >
              @for (user of userOptions; track user) {
                @if (user.id !== me.id) {
                  <mat-option [value]="user.id">{{ user.name + ' ' + user.surnames.split(' ')[0] }}</mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </div>

    <!-- RIGHT: manage schedule + add + save + options -->
    <div class="calendar-header-right">
      <!-- menu definitions (no visual impact) -->
      <mat-menu #menuConfigurarHorarios="matMenu">
        @if (viewedWeekState() === 'future') {
          <button
            mat-menu-item
            (click)="openConfigureNormalSchedule()"
            [disabled]="viewedWeekSchedulesLoading() || !viewedWeekSchedulesLoaded()"
          >
            <mat-icon>calendar_month</mat-icon>
            <span>Configurar horario habitual</span>
          </button>
        }
        <button
          mat-menu-item
          [matMenuTriggerFor]="menuGestionarSemana"
          [disabled]="viewedWeekSchedulesLoading() || !viewedWeekSchedulesLoaded()"
        >
          <mat-icon>date_range</mat-icon>
          <span>Gestionar esta semana</span>
        </button>
      </mat-menu>

      <mat-menu #menuGestionarSemana="matMenu">
        <button
          mat-menu-item
          (click)="openConfigureThisWeekSchedule()"
          [disabled]="viewedWeekSchedulesLoading() || !viewedWeekSchedulesLoaded()"
        >
          <mat-icon>insert_invitation</mat-icon>
          <span>Configurar excepción horaria</span>
        </button>
        <button mat-menu-item (click)="openRemoteWorkDialog()" [disabled]="isPastWeek()">
          <mat-icon>add_home_work</mat-icon>
          <span>Solicitar excepción de teletrabajo</span>
        </button>
      </mat-menu>

      @if (viewDate() !== null && active_contract !== null && user_selected && me) {
        <span
          [matTooltip]="
            user_selected.id !== me.id
              ? 'Solo puedes gestionar tu propio horario'
              : viewedWeekState() === 'past'
                ? 'Solo se puede gestionar el horario en el presente o en el futuro'
                : 'Gestionar horario'
          "
          matTooltipPosition="below"
        >
          <button
            mat-icon-button
            [matMenuTriggerFor]="menuConfigurarHorarios"
            [disabled]="
              user_selected.id !== me.id || viewedWeekState() === 'past' || viewedWeekSchedulesLoading() || !viewedWeekSchedulesLoaded()
            "
          >
            <mat-icon>edit_calendar</mat-icon>
          </button>
        </span>
      }

      @if (userOptions && user_selected && me && user_selected.id === me.id) {
        <div id="add-button">
          <button mat-mini-fab color="accent" [matTooltip]="'Crear nuevo evento'" (click)="onClickCreateNewEvent()">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-flat-button color="accent" [matMenuTriggerFor]="menuCreate">
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #menuCreate="matMenu">
            <button mat-menu-item (click)="onClickImportIcs()">
              <mat-icon>upload_file</mat-icon>
              <span>Importar desde archivo .ics</span>
            </button>
            <button mat-menu-item (click)="openCalendarLinkDialog()">
              <mat-icon>sync</mat-icon>
              <span>Sincronizar calendario</span>
            </button>
          </mat-menu>
          <input #inputFileImportIcs type="file" accept=".ics" (change)="onFileSelectedImportIcs($event)" style="display: none" />
        </div>
      }

      <button mat-stroked-button color="accent" (click)="save()" [disabled]="!changesAvailableToSave">
        <mat-icon>save</mat-icon>
        Guardar
      </button>

      @if (userOptions) {
        <button mat-icon-button [matMenuTriggerFor]="menuOpcionesCalendario" matTooltip="Opciones">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menuOpcionesCalendario="matMenu" class="calendar-options-menu">
          <div (click)="$event.stopPropagation()" class="menu-options-content">
            <mat-form-field appearance="outline" class="nobottom small full-width" [formGroup]="filterForm">
              <mat-select formControlName="user_id">
                @for (user of userOptions; track user) {
                  <mat-option [value]="user.id">{{ user.name + ' ' + user.surnames + (me.id === user.id ? ' (tú)' : '') }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="nobottom small full-width">
              <mat-select [formControl]="hour_segmented_height_ctrl">
                @for (s of segmentation_options; track s; let i = $index) {
                  <mat-option [value]="s.value">{{ s.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </mat-menu>
      }
    </div>
  </div>

  <div class="row">
    <ngx-dropzone class="col-12" (change)="onDropIcsFile($event)" [multiple]="false" [accept]="'text/calendar'" [disableClick]="true">
      <div id="calendar-container" #scrollContainer>
        <div id="dropzone-hover">¡Suelta el archivo ICS aquí para crear un evento!</div>
        <ng-template
          #weekViewHourSegmentTemplate
          let-segment="segment"
          let-locale="locale"
          let-segmentHeight="segmentHeight"
          let-isTimeLabel="isTimeLabel"
        >
          <div
            #segmentElement
            class="cal-hour-segment"
            [style.height.px]="segmentHeight"
            [class.cal-hour-start]="segment.isStart"
            [class.cal-after-hour-start]="!segment.isStart"
            [ngClass]="segment.cssClass"
            (mousedown)="startDragToCreate(segment, $event, segmentElement)"
          >
            @if (isTimeLabel) {
              <div class="cal-time">
                {{ segment.date | calendarDate: 'weekViewHour' : locale }}
              </div>
            }
          </div>
        </ng-template>

        <ng-template #tooltipTemplate let-event="event">
          @if (event.title && !event.meta?.hide_tooltip) {
            <div id="event-tooltip" [ngStyle]="{ 'background-color': event.color.secondary }">
              <span class="title">{{ event.title }}</span>
              <br />
              @if (event.subtitle) {
                <span class="subtitle">{{ event.subtitle }}</span>
              }
              @if (event.subtitle) {
                <br />
              }
              @if (event.company_product_phase_name) {
                <span class="company_product_phase_name">{{ event.company_product_phase_name }}</span>
              }
            </div>
          } @else {
            <div id="event-tooltip" style="display: none"></div>
          }
        </ng-template>
        <mwl-calendar-week-view
          [viewDate]="viewDateForCalendar()"
          [events]="events"
          [hourSegments]="hour_segments"
          [refresh]="refresh"
          [weekStartsOn]="weekStartsOn"
          [hourSegmentTemplate]="weekViewHourSegmentTemplate"
          (eventTimesChanged)="checkPermissions(events, $event) ? eventTimesChanged($event) : null"
          (beforeViewRender)="beforeWeekViewRender($event)"
          [hourSegmentHeight]="hour_segmented_height"
          (eventClicked)="eventClicked(castToCalendarEventCustomized($event.event))"
          [minimumEventHeight]="0"
          [hourDuration]="60"
          [tooltipTemplate]="tooltipTemplate"
        ></mwl-calendar-week-view>
      </div>
    </ngx-dropzone>
  </div>
</div>
